export default {
    namespaced: true,
    state: () => ({
        ThongTinTheKiemSoat: {
            IdNhomThe: null,
            TienTo: null,
            HauTo: "0000",
            KyHieuThe: null,
            DanhSachTheKiemSoat: [],
        },
    }),
    getters: {},

    mutations: {
        Set: (state, { key, data }) => {
            state[key] = data;
        },
        Reset_ThongTinTheKiemSoat: (state) => {
            state.ThongTinTheKiemSoat = {
                IdNhomThe: null,
                TienTo: null,
                HauTo: "0000",
                KyHieuThe: null,
                DanhSachTheKiemSoat: [],
            };
        },
    },

    actions: {
        LayDanhSachTheKiemSoat(store) {
            store;
            let defaultData = {
                data: [],
                groupCount: 0,
                summary: [0],
                totalCount: 0,
            };
            var load = this.$Helper.Common.DevExDataSourceCustom(
                async (loadOptions) => {
                    this.startLoading();
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachTheKiemSoat")
                        ).Post(loadOptions);

                        if (resp.Data.status) {
                            let data =
                                resp.Data.data && resp.Data.data.data
                                    ? resp.Data.data
                                    : defaultData;
                            return data;
                        } else return defaultData;
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    } finally {
                        this.stopLoading();
                    }
                },
                "IdThe" || null,
                async (key) => {
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachTheKiemSoat")
                        ).Post({
                            filter: ["IdThe", "=", key],
                        });
                        if (resp.StatusCode === 200) {
                            let data =
                                (resp.Data.data?.data || []).length > 0
                                    ? resp.Data.data.data[0]
                                    : {};
                            return data;
                        } else {
                            return {};
                        }
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    }
                }
            );
            return load;
        },

        async TaoMoiTheKiemSoat(store) {
            try {
                let dataPost = {
                    DanhSachThe:
                        store.state.ThongTinTheKiemSoat.DanhSachTheKiemSoat,
                };
                console.log("🚀 ~ dataPost:", dataPost);
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.TaoMoiNhieuTheKiemSoat")
                ).Post(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async CapNhatTheKiemSoat(store) {
            try {
                let dataPost = {
                    IdThe: store.state.ThongTinTheKiemSoat.IdThe,
                    MaThe: store.state.ThongTinTheKiemSoat.MaThe,
                    KyHieuThe: store.state.ThongTinTheKiemSoat.KyHieuThe,
                    IdNhomThe: store.state.ThongTinTheKiemSoat.IdNhomThe,
                    IdTrangThai: store.state.ThongTinTheKiemSoat.IdTrangThai,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.CapNhatTheKiemSoat")
                ).Put(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },

        async XoaTheKiemSoat({ state }, IdDnvt) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.TheKiemSoat") + `/${IdDnvt}`
                ).Delete();
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async KhoaTheKiemSoat(store) {
            try {
                let dataPost = {
                    IdThe: store.state.ThongTinTheKiemSoat.IdThe,
                    MaThe: store.state.ThongTinTheKiemSoat.MaThe,
                    KyHieuThe: store.state.ThongTinTheKiemSoat.KyHieuThe,
                    IdNhomThe: store.state.ThongTinTheKiemSoat.IdNhomThe,
                    IdTrangThai: this.$i18n.global.t("TrangThaiThe.DaKhoa"),
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.CapNhatTheKiemSoat")
                ).Put(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async MoKhoaTheKiemSoat(store) {
            try {
                let dataPost = {
                    IdThe: store.state.ThongTinTheKiemSoat.IdThe,
                    MaThe: store.state.ThongTinTheKiemSoat.MaThe,
                    KyHieuThe: store.state.ThongTinTheKiemSoat.KyHieuThe,
                    IdNhomThe: store.state.ThongTinTheKiemSoat.IdNhomThe,
                    IdTrangThai: this.$i18n.global.t("TrangThaiThe.KhaDung"),
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.CapNhatTheKiemSoat")
                ).Put(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
    },
};
